export default "__VITE_ASSET__9j40G4cT__"